// @ts-nocheck
// Libraries.
import { robotoRegular, scarpaGray800 } from '@habitech/shared';
import styled from 'styled-components';

export const Wrapper = styled.p`
    font-family: ${robotoRegular};
    font-size: 24px;
    font-weight: bold;
    color: ${scarpaGray800};
    
`